module.exports = "<div class=\"button-select\">\n    <label ng-repeat=\"option in term.options track by option.code\"\n           id=\"button-select-{{option.code}}\"\n           uib-btn-radio=\"option.code\"\n           ng-model=\"term.value\"\n           ng-disabled=\"disabledIf\"\n    >\n        <!-- span is needed vertical centering -->\n        <span>{{option.name}}</span>\n    </label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/basler/templates/button-select-term.html
// module id = 564
// module chunks = 0